import React from "react";
import "./BlogCards.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";

const blogs = [
  {
    id: 1,
    title: "International Life in Italy: An Overview",
    description:
      "Learn Italy is one of the most popular study-abroad destinations in the world...",
    image:
      "https://images.ctfassets.net/qr8kennq1pom/5yyp91AA05Dle0GotsvgNL/df818550632ae0d75e7a71d3d5ff35e6/mike-swigunski-HXtjr6tJGv8-unsplash.jpg", // Replace with your image URL
    path: "/blogs", // Unique path for this blog
  },
  {
    id: 2,
    title: "6-Year Curriculum of Medicine and Surgery in Italy",
    description:
      "The master's degree in medicine and surgery in Italy spans six years...",
    image:
      "https://www.italymedicalschools.com/wp-content/uploads/2019/07/italymedicalschools-university-of-pavia4.jpg",
    path: "/blogss", // Unique path for this blog
  },
  {
    id: 3,
    title: "IMAT Syllabus 2025: Best Books to Use and Study Strategies in 2025 for IMAT",
    description:
      "The IMAT 2024 was a surprising turn from the previous paper, many things changed...",
    image:
      "https://www.avanse.com/blogs/images/Planning-to-study-abroad.jpg",
    path: "/blogsss", // Unique path for this blog
  },
];

const BlogCards = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleReadMore = (path) => {
    navigate(path); // Navigate to the specified path
  };

  return (
    <div className="blog-cards-container">
      <h1 className="page-title">Our Latest Blogs</h1>
      <div className="blog-cards-grid">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-card">
            <img src={blog.image} alt={blog.title} className="blog-card-image" />
            <div className="blog-card-content">
              <h2 className="blog-card-title">{blog.title}</h2>
              <p className="blog-card-description">{blog.description}</p>
              <button
                onClick={() => handleReadMore(blog.path)}
                className="blog-card-link"
              >
                Read More →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogCards;